// import axios from 'axios';
import api from './api';

const APIAutenticacao = {
  geraChave: async (matricula, token = '') => {
    const response = await api
      .get(`GeraChave?matricula=${matricula}&token=${token}`)
      .then((res) => {
        return res.data[0].Chave;
      })
      .catch((err) => {
        console.error(`Erro ao gerar a chave: ${err}`);
        return false;
      });
    return response;
  },
  desativaSessao: async (matricula, token) => {
    const response = await api
      .post('DesativaSessao', {
        matricula,
        token,
      })
      .then((res) => {
        if (res.data[0] !== undefined) {
          return true;
        }
        console.error(`Erro na API para deslogar: ${res.data[0]}`);
        return false;
      })
      .catch((err) => {
        console.error(`Ocorreu um erro ao deslogar: ${err}`);
        return false;
      });
    return response;
  },
  ativaSessao: async (matricula, token) => {
    // const ip = await axios.get('https://api.ipify.org?callback=');
    const response = await api
      .post('AtivaSessao', {
        matricula,
        token,
        ip: '123',
        aplicacao: 'Web',
      })
      .then((res) => {
        if (res.data[0].linhasafetadas === 1) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.error(error);
        return false;
      });
    return response;
  },
  validaLogin: async (matricula, senha) => {
    const response = await api
      .post('AutenticaUsuario', {
        matricula,
        senha,
      })
      .then(async (res) => {
        if (res.data[0] !== undefined) {
          localStorage.setItem('Token', res.data[0].token);
          const retAtivaSessao = await APIAutenticacao.ativaSessao(
            matricula,
            res.data[0].token
          );
          if (retAtivaSessao === true) {
            return res.data[0];
          }
          return retAtivaSessao;
        }
        return false;
      })
      .catch((err) => {
        console.error(`Erro ao validar login: ${err}`);
        return err;
      });
    return response;
  },
  validaLoginADM: async (token, matricula) => {
    localStorage.setItem('Token', token);
    return {
      matricula,
      token,
      nivelsessao: 4,
    };
  },
  validaSessao: async (matricula, token, metodo = '') => {
    const response = await api
      .post('ValidaSessao', {
        matricula,
        token,
        metodo,
      })
      .then((res) => {
        if (res.data[0] === undefined) return false;
        if (res.data[0].linhasafetadas > 0) {
          return true;
        }
        return false;
      })
      .catch((err) => {
        console.error(`Erro ao validar sessão: ${err}`);
        return false;
      });
    return response;
  },
  recuperaSenha: async (matricula) => {
    return await api.get(`AutenticaUsuario2Fatores?matricula=${matricula}`);
  },
  verificaResetEspecial: (matricula) => {
    const response = api
      .get(`VerificarResetEspecial?matricula=${matricula}`)
      .then((res) => {
        return res.data.isReset;
      })
      .catch((err) => console.error('Erro ao verificar reset de senha: ', err));
    return response;
  },
};

export { APIAutenticacao };
